export enum RoutePaths {
  // root paths
  ROOT = "/",
  // user feedback paths
  USER_FEEDBACK_DETAILS = "/:issueId",
  USER_FEEDBACK_LOGS = "/:issueId/activity-history",

  // error paths
  NOT_FOUND = "/not-found",
  ERROR = "/error",
}
